import {
  fetchPlayersQuotations,
  updatePlayerActive,
  updatePlayerPosition,
  updatePlayerProperty,
  updatePlayerQuotation,
  updatePlayerUltraPosition,
} from '../../../entities/player';

export const scope = 'PLAYERS_LIST_WIDGET';

export function fetchPlayersIfNeeded(payload) {
  return (dispatch, getState) => {
    const widget = getState().app.onSite.players.listWidget;

    if (!widget.info.isFetching)
      dispatch(fetchPlayersQuotations(payload, scope));
  };
}

export function updateQuotation(payload) {
  return (dispatch, getState) => {
    const widget = getState().app.onSite.players.listWidget;

    if (!widget.info.isFetching)
      dispatch(updatePlayerQuotation(payload, scope));
  };
}

export function updateUltraPosition(id, payload) {
  return (dispatch, getState) => {
    const widget = getState().app.onSite.players.listWidget;

    if (!widget.info.isFetching)
      dispatch(updatePlayerUltraPosition(id, payload, scope));
  };
}

export function updatePosition(id, payload) {
  return (dispatch, getState) => {
    const widget = getState().app.onSite.players.listWidget;

    if (!widget.info.isFetching)
      dispatch(updatePlayerPosition(id, payload, scope));
  };
}

export function updateActive(id, payload) {
  return (dispatch, getState) => {
    const widget = getState().app.onSite.players.listWidget;

    if (!widget.info.isFetching)
      dispatch(updatePlayerActive(id, payload, scope));
  };
}

export function updatePlayer(id, payload) {
  return (dispatch, getState) => {
    const widget = getState().app.onSite.players.listWidget;

    if (!widget.info.isFetching)
      dispatch(updatePlayerProperty(id, payload, scope));
  };
}



// WEBPACK FOOTER //
// ./src/actions/app/onSite/players/listWidget.js